import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CreateBookingWrapper from "../CreateBooking/CreateBookingWrapper";
import ViewBookings from "./ViewBookings";
import {
  bookings,
  canCreateBooking,
  displayBookings,
  getBranches,
  getActiveReasons,
  setDisplayBookings,
  getAvailableReasons,
  landingDataLoaded,
  bookingErrors,
  cancelBookingSubmissionStarted,
} from "../../features/BookingsSlice";
import { useEffect, useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { requesterDetailsFormState } from "../../features/CaptureDetailsSlice";
import { getIdentificationNumber } from "../../features/Helper";
import { CaptchaDetailsForm } from "../../models/CaptureDetailsForm";

function Landing() {
  const dispatch = useDispatch();
  const viewBookings = useSelector(displayBookings);
  const foundBookings = useSelector(bookings);
  const canCreateNewBookings = useSelector(canCreateBooking);
  const allLandingDataLoaded = useSelector(landingDataLoaded);
  const bookingErrorState = useSelector(bookingErrors);
  const hasCancelBookingStarted = useSelector(cancelBookingSubmissionStarted);
  const capturedDetailsForm = useSelector(requesterDetailsFormState);

  const [identification, setIdentification] = useState<string>("");

  useEffect(() => {
    dispatch(getBranches());
    dispatch(getActiveReasons());
    dispatch(getAvailableReasons());
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    setIdentification(getIdentificationNumber(capturedDetailsForm?.values as CaptchaDetailsForm));
  }, [dispatch, capturedDetailsForm?.values]);

  return (
    <Container sx={{ mt: 4, height: 1 }}>
      {!viewBookings ? (
        <Grid item sx={{ height: 1 }}>
          <CreateBookingWrapper />
        </Grid>
      ) : (
        <>
          {canCreateNewBookings ? (
            <section
              style={{
                marginBottom: "22px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #E1E1E1",
              }}
            >
              <h1
                style={{
                  color: "#00558B",
                  fontSize: "32px",
                  fontWeight: "bold",
                }}
              >
                Bookings
              </h1>
              <Button
                variant="contained"
                onClick={() => {
                  dispatch(setDisplayBookings(false));
                }}
              >
                Create Booking
              </Button>
            </section>
          ) : null}

          {!canCreateNewBookings && foundBookings.length > 0
            ? <Box sx={{ display: "flex", alignItems: "center", p: "12px", backgroundColor: "#E3EFF57D", borderRadius: "8px", mb: "22px" }}>
                <InfoOutlinedIcon color="primary" sx={{ mr: "12px", fontSize: "1.8rem" }} />
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography color="primary"><strong>Please Note:</strong></Typography>
                  <Typography color="primary" sx={{ fontSize: "15px" }}>The taxpayer <strong>{identification}</strong> already has an eBooking</Typography>
                </Box>
              </Box>
            : null
          }

          <Grid item>
            <ViewBookings bookings={foundBookings ?? []} />
          </Grid>
        </>
      )}

      <Backdrop
        sx={{ color: "#fff", zIndex: 200, flexDirection: "column" }}
        open={
          (allLandingDataLoaded.length <= 2 || hasCancelBookingStarted) &&
          (bookingErrorState === null || bookingErrorState.error === null)
        }
      >
        <CircularProgress color="inherit" size="4rem" thickness={4} />
        <Typography color="white" sx={{ mt: "1rem", fontSize: "18px" }}>
          {hasCancelBookingStarted ? "Cancelling Booking ..." : "Loading ..."}
        </Typography>
      </Backdrop>
    </Container>
  );
}

export default Landing;
